import React, {Fragment} from 'react';
import {Button} from "../../../components/Button";
import Title from "../../../components/Title";
import {bindActionCreators} from "redux";
import {fetchCurrentUser, updateCurrentUser} from "../../../../creators/currentUser";
import connect from "react-redux/es/connect/connect";
import {PageLoader} from "../../../components/Loader";
import {CheckboxInputField} from "../../../components/FormField";
import {config} from "../../../../config";
import Helmet from "react-helmet";
import {contextBigPlan} from "../../../../libs/contextBigPlan";


class SettingProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allowed: false,
            toValidate: false,
            displayLastVisitors: false,
            chatWithOnlyWithFriends : false,
            notDisplaySignatureInForum : false,
            notDisplayOrientationInProfile : false,
            displayBigPlan : false,
            autoFollowTopicWhereIParticipated : true
        };
        this.handleSetting = this.handleSetting.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount(oldProps) {
        this.props.fetchCurrentUser();
        const newProps = this.props;
        if ((oldProps && oldProps.currentUserInitialized !== newProps.currentUserInitialized) || newProps.currentUserInitialized === true) {
            let setting = newProps.currentUser.setting;
            this.setState({
                allowed: setting.comment.allowed,
                toValidate: setting.comment.toValidate,
                displayLastVisitors: setting.displayLastVisitors,
                chatWithOnlyWithFriends : setting.chatWithOnlyWithFriends,
                notDisplaySignatureInForum : setting.notDisplaySignatureInForum,
                notDisplayOrientationInProfile : setting.notDisplayOrientationInProfile,
                displayBigPlan : setting.displayBigPlan,
                autoFollowTopicWhereIParticipated : setting.autoFollowTopicWhereIParticipated
            });
        }
    }

    handleSetting(name, value) {
        this.setState({[name]: value})
    }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        let currentUser = {
            setting: {
                comment : {
                    allowed: this.state.allowed,
                    toValidate: this.state.toValidate,
                },
                displayLastVisitors: this.state.displayLastVisitors,
                chatWithOnlyWithFriends : this.state.chatWithOnlyWithFriends,
                notDisplaySignatureInForum : this.state.notDisplaySignatureInForum,
                notDisplayOrientationInProfile : this.state.notDisplayOrientationInProfile,
                displayBigPlan : this.state.displayBigPlan,
                autoFollowTopicWhereIParticipated : this.state.autoFollowTopicWhereIParticipated
            },
        };
        if (!this.props.currentUserLoading) {
            this.props.updateCurrentUser(currentUser);
            this.context.setFilterToggle({isToggle: this.state.displayBigPlan})
            localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_gp`, this.state.displayBigPlan);
        }
    }

    render() {
        return !this.props.currentUserInitialized ? <PageLoader/> : (
            <Fragment>
                <div className="settings-wrapper">
                    <Helmet>
                        <title>{config.preTitle}Paramètres de profil{config.postTitle}</title>
                    </Helmet>
                    <div className="block">
                        <Title className={"settings-title"} heading={"heading-2"} display={"display-2"}>Paramètres de profil</Title>
                        <form className="content" onSubmit={(e) => this.handleSubmit(e)}>

                            <CheckboxInputField checked={this.state.allowed}
                                                onChange={() => this.handleSetting('allowed', !this.state.allowed)}
                                                htmlFor={"allow"}
                                                id="allow"
                                                className={"my-8"}
                                                label={"Permettre aux membres de publier des statuts sur mon profil"}/>
                            <CheckboxInputField checked={this.state.toValidate}
                                                onChange={() => this.handleSetting('toValidate', !this.state.toValidate)}
                                                htmlFor="moderate"
                                                id="moderate"
                                                className={"my-8"}
                                                label={"Permettre aux membres de mettre des commentaires sur mes statuts"}/>
                            <CheckboxInputField checked={this.state.displayLastVisitors}
                                                onChange={() => this.handleSetting('displayLastVisitors', !this.state.displayLastVisitors)}
                                                htmlFor="lastVisitor"
                                                id="lastVisitor"
                                                className={"my-8"}
                                                label={"Afficher les derniers visiteurs sur mon profil"}/>

                            <CheckboxInputField checked={this.state.chatWithOnlyWithFriends}
                                                onChange={() => this.handleSetting('chatWithOnlyWithFriends', !this.state.chatWithOnlyWithFriends)}
                                                htmlFor="chatWithOnlyWithFriends"
                                                id="chatWithOnlyWithFriends"
                                                className={"my-8"}
                                                label={"Etre contacté sur le chat uniquement par mes amis"}/>

                            <CheckboxInputField checked={this.state.notDisplaySignatureInForum}
                                                onChange={() => this.handleSetting('notDisplaySignatureInForum', !this.state.notDisplaySignatureInForum)}
                                                htmlFor={"notDisplaySignatureInForum"}
                                                id="notDisplaySignatureInForum"
                                                className={"my-8"}
                                                label={"Ne pas afficher les signatures dans le forum"}/>

                            <CheckboxInputField checked={this.state.notDisplayOrientationInProfile}
                                                onChange={() => this.handleSetting('notDisplayOrientationInProfile', !this.state.notDisplayOrientationInProfile)}
                                                htmlFor={"notDisplayOrientationInProfile"}
                                                id="notDisplayOrientationInProfile"
                                                className={"my-8"}
                                                label={"Ne pas afficher mon orientation sur mon profil"}/>

                            <CheckboxInputField checked={this.state.displayBigPlan}
                                                onChange={() => this.handleSetting('displayBigPlan', !this.state.displayBigPlan)}
                                                htmlFor={"displayBigPlan"}
                                                id="displayBigPlan"
                                                className={"my-8"}
                                                label={"Déverrouiller les gros plans"}/>

                            <CheckboxInputField checked={this.state.autoFollowTopicWhereIParticipated}
                                                onChange={() => this.handleSetting('autoFollowTopicWhereIParticipated', !this.state.autoFollowTopicWhereIParticipated)}
                                                htmlFor={"autoFollowTopicWhereIParticipated"}
                                                id="autoFollowTopicWhereIParticipated"
                                                className={"my-8"}
                                                label={"Suivre automatiquement un sujet auquel j’ai participé"}/>

                            <div className="settings-btn-group">
                                <Button size={"medium"}
                                        btnStyle={"primary-reverse"}
                                        btnType={"submit"}
                                        loading={this.props.currentUserSubmitting}
                                        content={"Enregistrer"}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Fragment>
        )
    }
}

SettingProfile.contextType = contextBigPlan;
const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserSubmitting: state.currentUser.submitting,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SettingProfile);

